import { text0 } from '@osmosis/tailwind-ui/styles/text';
import { Box } from '@osmosis/tailwind-ui/components/Box';
import { useIntl } from 'react-intl';
import { cn } from '@osmosis/tailwind-ui/helpers/classes';

/**
 * Returns Duration component.
 */
export const Duration = ({
  duration,
  className,
}: {
  duration: string;
  className?: string;
}) => {
  const { formatMessage } = useIntl();

  return (
    <Box
      className={cn(
        `leading-4 p-1 rounded opacity-80 bg-gray-800 text-xs`,
        text0,
        className,
      )}
      aria-label={formatMessage(
        {
          id: 'video.duration',
          defaultMessage: 'Duration: {minutes} minutes and {seconds} seconds',
        },
        { minutes: duration.split(':')[0], seconds: duration.split(':')[1] },
      )}
    >
      {duration}
    </Box>
  );
};
